import {Box} from 'src/design/atoms/Box';
import {Divider} from 'src/design/atoms/Divider';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {stateLegendItems, nodeTypeLegendItems} from './nexusGraphConfig';

export const StateLegend: React.FC = () => (
  <Group gap="md">
    {stateLegendItems.map(item => (
      <Group key={item.label} gap={6}>
        <Box
          style={{
            width: 12,
            height: 12,
            borderRadius: 2,
            backgroundColor: item.color,
          }}
        />
        <Text size="xs" c="dimmed">
          {item.label}
        </Text>
      </Group>
    ))}
    <Divider orientation="vertical" />
    {nodeTypeLegendItems.map(item => (
      <Group key={item.label} gap={6}>
        <Box
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            border: item.dashed ? '1.5px dashed var(--mantine-color-gray-4)' : '1px solid var(--mantine-color-gray-4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {item.icon}
        </Box>
        <Text size="xs" c="dimmed">
          {item.label}
        </Text>
      </Group>
    ))}
  </Group>
);
